import React from "react";

import { FormProvider } from "react-hook-form";
import { useHistory } from "react-router-dom";

import { CustomerAccountPage } from "@/components/CustomerPage";
import { InternalTextLink } from "@/components/Links";
import ResendVerificationEmailButton from "@/components/ResendVerificationEmailButton";
import {
  CMP_PRACTITIONER_URL,
  CMP_SIGNIN_URL,
  LOGIN_URL,
  CMP_REQUEST_PASSWORD_RESET_DONE,
  REQUEST_PASSWORD_RESET_DONE
} from "@/core/urls";
import { REQUEST_PASSWORD_RESET_MUTATION } from "@/graphql/accounts";
import useDjangoGraphqlForm from "@/hooks/form/useDjangoGraphqlForm";
import useDocTitle from "@/hooks/use-doc-title";
import Center from "@/tpo/Center";
import ControlledFormField from "@/tpo/ControlledFormField";
import FloatingLabelInput from "@/tpo/FloatingLabelInput";
import Stack from "@/tpo/Stack";
import B2CHeader from "@/tpo/header/B2CHeader";

import Box from "../Box";

export default function RequestResetPage({ partners }) {
  useDocTitle("Request password reset");
  const history = useHistory();

  const api = useDjangoGraphqlForm({
    mutation: REQUEST_PASSWORD_RESET_MUTATION,
    mutationName: "requestPasswordResetMutation",
    defaultValues: {
      email: "",
      usePartnerPage: !!partners
    },
    handleSuccess: () => {
      history.push(partners ? CMP_REQUEST_PASSWORD_RESET_DONE : REQUEST_PASSWORD_RESET_DONE);
    }
  });

  return (
    <>
      <B2CHeader />
      <CustomerAccountPage
        jumbotronProps={{
          title: "Password reset",
          bg: partners ? "partners" : "purple",
          color: partners ? "dark" : "white"
        }}
      >
        <FormProvider {...api.methods}>
          <Stack
            gap={40}
            as="form"
            onSubmit={api.methods.handleSubmit(api.onSubmit)}
            maxWidth={760}
            mx="auto"
          >
            <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
              Please provide the email address associated with your account below, and we'll send
              you a link to reset your password.
            </Box>
            <Stack maxWidth={600} width="100%" mx="auto" gap={40}>
              <ControlledFormField name="email" label="Email" Component={FloatingLabelInput} />
              <Center>
                <ResendVerificationEmailButton errorField="email" />
              </Center>
              <Stack gap={20}>
                <InternalTextLink
                  href={partners ? CMP_SIGNIN_URL : LOGIN_URL}
                  textAlign="center"
                  display="block"
                >
                  Click here to sign in
                </InternalTextLink>
                {partners ? (
                  <InternalTextLink href={CMP_PRACTITIONER_URL} textAlign="center" display="block">
                    Click here to apply
                  </InternalTextLink>
                ) : null}
              </Stack>
            </Stack>
          </Stack>
        </FormProvider>
      </CustomerAccountPage>
    </>
  );
}
